import { useCallback } from 'react'

import { InvoiceDocumentType } from '@features/invoices/enums/invoiceDocumentType'
import { useDuplicateSalesDocument } from '@features/invoices/hooks/useDuplicateSalesDocument'

import { useInvoice } from '../../../contexts/invoiceContext'

export const useDuplicateInvoice = () => {
  const { invoiceId } = useInvoice()
  const { duplicateSalesDocument } = useDuplicateSalesDocument()

  const duplicateInvoice = useCallback(
    () => duplicateSalesDocument(invoiceId, InvoiceDocumentType.Invoice),
    [duplicateSalesDocument, invoiceId],
  )

  return {
    duplicateInvoice,
  }
}
